import { render, staticRenderFns } from "./cola_crm.vue?vue&type=template&id=3ff951fc"
import script from "./cola_crm.vue?vue&type=script&lang=js"
export * from "./cola_crm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports